import { Action } from 'redux'
import { CalendarActions } from '../../../reducers/bookingCalendar/actionNames'

export const mergeEventLabels = (labels): IMergeEventLabels => ({
  labels,
  type: CalendarActions.MergeEventLabels,
})

export interface IMergeEventLabels
  extends Action<CalendarActions.MergeEventLabels> {
  labels: {
    [eventId: string]: string[]
  }
}
